// @flow
import { createReducer } from "redux-act";

import * as actions from "../../actions";

const initialState = {
	user: {
		is_pending: false,
		error: null,
	},
	login: {
		is_pending: false,
		error: null,
	},
	logout: {
		is_pending: false,
		error: null,
	},
	data: {},
	coach_trial_popup: false
};

export const user = createReducer({}, initialState);

user.on(actions.fetchUser, state => ({
	...state,
	user: {
		...state.user,
		is_pending: true,
		error: null,
	}
}));

user.on(actions.fetchUserSuccess, (state, payload) => {
	return {
		...state,
		user: {
			...state.user,
			is_pending: false,
			error: null,
		},
		data: payload,
	};
});

user.on(actions.fetchUserFailed, (state, payload) => {
	return {
		...state,
		user: {
			...state.user,
			is_pending: false,
			error: payload,
		},
	};
});


user.on(actions.postSSO, state => ({
	...state,
	login: {
		...state.login,
		is_pending: true
	}
}));

user.on(actions.postUserLoginSuccess, (
	state: Object,
	payload: any
): Object => {
	return {
		...state,
		login: {
			...state.login,
			is_pending: false,
		},
	};
});

user.on(actions.postSSOFailed, (state, payload) => {
	return {
		...state,
		login: {
			...state.login,
			is_pending: false,
			error: payload
		}
	};
});

user.on(actions.postUserLoginFailed, (state, payload) => {
	return {
		...state,
		login: {
			...state.login,
			is_pending: false,
			error: payload
		}
	};
});

user.on(actions.userLogout, (
	state: Object,
	payload: any
): Object => {

	return {
		...state,
		logout: {
			...state.logout,
			is_pending: true,
			error: initialState.logout.error
		},
	};
});

user.on(actions.userLogoutSuccess, (
	state: Object,
	payload: any
): Object => {

	return {
		...state,
		logout: {
			...state.logout,
			is_pending: false,
		},
		data: initialState.data
	};
});

user.on(actions.userLogoutFailed, (
	state: Object,
	payload: any
): Object => {

	return {
		...state,
		logout: {
			...state.logout,
			is_pending: false,
			error: payload
		}
	};
});

user.on(actions.setUserCoachBanner, (state: Object): Object => ({
	...state,
	coach_trial_popup: true
}));

export default user;


// WEBPACK FOOTER //
// ./src/modules/reducers/user/index.js